import {AfterContentInit, Component, ContentChildren, Optional, QueryList} from '@angular/core';
import {NgForm, NgModel} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ValidatorResult} from '../../validators/validator-result';
import {AppConstants} from '../../utils/app-constants';

@Component({
  selector: 'app-form-group',
  templateUrl: './form-group.component.html',
  styles: []
})
export class FormGroupComponent implements AfterContentInit {

  control: NgModel;

  @ContentChildren(NgModel) models: QueryList<NgModel>;

  constructor(@Optional() public ngForm: NgForm,
              private translateService: TranslateService) {
  }

  ngAfterContentInit() {
    if (this.models.first) {
      this.control = this.models.first;
    }
  }

  getErrorLabel(): string {
    if (this.control && this.control.errors) {
      const errorKeys = Object.keys(this.control.errors);
      
      // Priority list for errors
      const priorityKeys = ['matDatepickerParse', 'pattern', 'matDatepickerMin', 'matDatepickerMax', 'required'];
      
      let errorKey = errorKeys[0]; // Default to first error
      
      // Find the first error in the priority list that's present
      for (const priorityKey of priorityKeys) {
        if (errorKeys.includes(priorityKey)) {
          errorKey = priorityKey;
          break;
        }
      }
      
      const errorValue = this.control.errors[errorKey];
      if (errorValue && errorValue instanceof ValidatorResult) {
        return errorValue.getValidatorResultLabel(this.translateService);
      } else {
        return this.translateService.instant(AppConstants.VALIDATORS_PREFIX + errorKey);
      }
    }
  }

}
